import { base_colorAction } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH2 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup,
  .BaseModal-Content.interactive {
    width: 750px;
  }

  &.EditCardDetailsModal .BaseModal-Body {
    padding: ${spacing(10)};
  }

  .EditCardDetailsModal-header {
    ${fontH2};
    margin-bottom: ${spacing(6)};
  }

  /* The shared LockedIcon ships with a grey stroke baked into the path
     attribute; override it here so the locked card-number row reads as
     "info, not disabled" per the design. */
  .LockedIcon path {
    stroke: ${base_colorAction};
  }

  .EditCardDetailsModal-form {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .EditCardDetailsModal-row-pair {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(5)};
  }

  .EditCardDetailsModal-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: ${spacing(5)};
  }
`
